import DoneIcon from '@mui/icons-material/Done';
import { Divider } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { ReactComponent as CopySvg } from 'assets/svg/SharableLinkCopyAction.svg';
import { useState } from 'react';
import { Customization } from 'types/Customization';
import ProgressBar from './ProgressBar';

const baseUrl = 'https://hello-data-ai-search-plugin.vercel.app/';
export const Setup = () => {
    const [copied, setCopied] = useState(false);

    const queryClient = useQueryClient();
    const customization = queryClient.getQueryData(['getCustomization']) as Customization;

    const handleCopy = async () => {
        const link = `${baseUrl}?widgetId=${customization.widgetId}`;
        await navigator.clipboard.writeText(link);
        setCopied(true);
        setTimeout(() => setCopied(false), 1000);
    };
    return (
        <div className="bg-white rounded-lg shadow-sm min-h-screen my-8">
            <div className="flex">
                <div className="w-3/5 p-6">
                    <h2 className="text-2xl font-semibold mb-2">Getting Started</h2>
                    <p className="text-gray-600">
                        Enhance your WordPress website with the hello:data search plugin, allowing visitors to easily search and discover your property
                        listings. Follow these steps to get started:
                    </p>
                    <div className="my-5">
                        <Divider />
                    </div>
                    <div className="mt-10">
                        <ProgressBar />
                    </div>
                </div>

                <div className="w-2/5 bg-gray-50 min-h-screen p-6">
                    <h3 className="text-lg font-medium mb-2">Live Link</h3>
                    <p className="text-sm text-gray-600 mb-2">Add an iframe with this Link to show the Plugin</p>
                    <div className="flex gap-2">
                        <div className="flex items-center flex-1 border rounded-lg p-2">
                            <code className="flex-1">
                                {customization.widgetId ? `${baseUrl}?widgetId=${customization.widgetId}` : 'After saving the link will be displayed here.'}
                            </code>
                            {customization.widgetId && (
                                <button
                                    onClick={handleCopy}
                                    className={`transition-colors duration-200 p-2 rounded-full
                            ${copied ? 'bg-green-100' : 'text-gray-500 hover:text-gray-700'}`}
                                >
                                    {copied ? <DoneIcon className="w-5 h-5 text-green-600" /> : <CopySvg className="w-5 h-5" />}
                                </button>
                            )}
                        </div>
                    </div>
                    <p className="text-sm text-gray-600 mt-2">
                        If you have any assistance, please{' '}
                        <a href="mailto:info@hellohere.es" className="text-blue-600 hover:underline">
                            Contact us
                        </a>
                    </p>
                </div>
            </div>
        </div>
    );
};
